import TransactionPage, { TransactionPageComponent } from '../TransactionPage';

export { TransactionPageComponent };
export default TransactionPage;
